import React, { useEffect, useRef, useState, useMemo } from "react";
import Form from "react-bootstrap/Form";
import { ApiKey, LoginUrl, RegisterUrl, ResetPasswordUrl, GooglePrefilClientId } from "../config";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";




const Login = ({ OnSuccess }) => {
  const [email, setEmail] = useState("");
  const [email2, setEmail2] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [isSignIn, setIsSignIn] = useState(true);
  const [mobilenumber, setMobileNumber] = useState("");
  const [name, setName] = useState("");
  const [errorMsg, setErrorMsg] = useState({msg: "", isError: 1});
  const [isLoading, setLoading] = useState(false);
  const scrollError = useRef(null);
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Password visibility states
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  // Field-specific error states
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  
  // prefill logic
const googlePrefill = () => {
  if (!window.google) return;

  const client = window.google.accounts.oauth2.initTokenClient({
    client_id: GooglePrefilClientId,
    scope: "openid email profile",
    callback: async (tokenResponse) => {
      if (!tokenResponse?.access_token) return;

      const res = await fetch(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`
          }
        }
      );

      const profile = await res.json();

      setEmail(profile.email || "");
      setEmail2(profile.email || "");
      setName(profile.name || "");
    }
  });

  client.requestAccessToken(); // popup only
};

  
  // Form validity state
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
  if (isSignIn) return;           
  if (!window.google) return;
}, [isSignIn]);

  useEffect(() => {
    setIsSignIn(location.pathname === "/login" ? true : false);
  }, [location.pathname]);
  function validMobileNumber(mobilenumber) {
    return (
      mobilenumber &&
      mobilenumber.toString().length === 10 &&
      mobilenumber > 6000000000
    );
  }
  // Use useEffect to check form validity whenever relevant fields change
  useEffect(() => {
    // Email validation
    let emailValid = email && validMail(email);
    // Password validation
    let passwordValid = password && password.length >= 7;
    // Form validity for sign in
    let formValid = emailValid && passwordValid;

    // Additional validations for signup
    if (!isSignIn) {
      // Name validation
      let nameValid = name && name.length > 0;
      // Mobile validation
      let mobileValid = mobilenumber && validMobileNumber(mobilenumber);
      // Email confirmation
      let emailsMatch = email === email2;
      // Password confirmation
      let passwordsMatch = password === password2;
      // Agreement check
      let agreementValid = isAgreementChecked;
      formValid =
        formValid &&
        nameValid &&
        mobileValid &&
        emailsMatch &&
        passwordsMatch &&
        agreementValid;
  }

    setIsFormValid(formValid);
  }, [
    email,
    email2,
    password,
    password2,
    name,
    mobilenumber,
    isAgreementChecked,
    isSignIn,
  ]);
 
  function validateFormOnSubmit() {
    // Reset field-specific errors
    setEmailError("");
    setPasswordError("");
    setNameError("");
    setMobileError("");
    let isValid = true;
    // Email validation
    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!validMail(email)) {
      setEmailError("Invalid email format");
      isValid = false;
  }
    // Password validation
    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    } else if (password.length < 7) {
      setPasswordError("Password must be at least 7 characters");
      isValid = false;
    }
    
    // Additional validations for signup
    if (!isSignIn) {
      // Name validation
      if (!name) {
        setNameError("Name is required");
        isValid = false;
  }
      // Mobile validation
      if (!mobilenumber) {
        setMobileError("Mobile number is required");
        isValid = false;
      } else if (!validMobileNumber(mobilenumber)) {
        setMobileError("Invalid Indian mobile number");
        isValid = false;
      }
      // Email confirmation
      if (email !== email2) {
        setEmailError("Email addresses do not match");
        isValid = false;
      }
      // Password confirmation
      if (password !== password2) {
        setPasswordError("Passwords do not match");
        isValid = false;
      }
      // Agreement check
      if (!isAgreementChecked) {
        setMsgFlash("Please agree to the Terms of Service and Privacy Policy");
        isValid = false;
      }
    }
    return isValid;
  }
  function handleSubmit(event) {
    event.preventDefault();
    if (!validateFormOnSubmit()) {
      return;
    }
    setLoading(true);
    let req = {
      email: email.toLowerCase(),
      password: password,
    };
    const headers = { 
      "x-api-key": ApiKey,
    };
    if (!isSignIn) {
      req["name"] = name;
      req["mobilenumber"] = mobilenumber;
      axios
        .post(RegisterUrl, req, { headers: headers })
        .then((resp) => {
          setLoading(false); 
          navigate("/login");
          setMsgFlash("Registration Successful. Please Sign In", 0);
        })
        .catch((err) => {
          setLoading(false);
          setMsgFlash(
            err.response?.data?.message ||
              "Registration failed. Please try again."
          );
        });
    } else {
      axios
        .post(LoginUrl, req, { withCredentials: true, headers: headers })
        .then((resp) => {
          localStorage.setItem("IsPremiumUser", resp.data.isPremiumUser);
          localStorage.setItem("UsersName", resp.data.user.name);
          setLoading(false);
          navigate("/");
          OnSuccess(req.email);
        })
        .catch((err) => {
          setLoading(false);
          setMsgFlash(
            err.response?.data?.message ||
              "Login failed. Please check your credentials."
          );
        });
  }
}

const validatePassword = (passwordtest) => {
  // Check the minimum length requirement
  if (passwordtest.length < 8) {
    return "Password must be at least 8 characters long.";
  }

  // Check for at least one uppercase letter
  if (!/[A-Z]/.test(passwordtest)) {
    return "Password must contain at least one uppercase letter.";
  }

  // Check for at least one lowercase letter
  if (!/[a-z]/.test(passwordtest)) {
    return "Password must contain at least one lowercase letter.";
  }

  // Check for at least one numeric digit
  if (!/[0-9]/.test(passwordtest)) {
    return "Password must contain at least one numeric digit.";
  }

  // Check for at least one special character
  if (!/[!@#$%^&*()|}{}":;'><.,]/.test(passwordtest)) {
    return "Password must contain at least one special character (!, @, #, etc).";
  }

  // All requirements have been met
  return "";
  };
  function ResetPassword() {
    if (!validMail(email)) {
      setEmailError("Please enter a valid email address");
      return;
}
    setLoading(true);
    var req = {
      email: email.toLowerCase(),
      loginUrl: window.location.href,
    };
    const headers = {
      "x-api-key": ApiKey,
    };
    axios
      .post(ResetPasswordUrl, req, { headers: headers })
      .then((resp) => {
        setLoading(false);
        setMsgFlash("Mail Sent! Please check your mailbox", 0);
      })
      .catch((err) => {
        setLoading(false);
        setMsgFlash(
          err.response?.data?.message ||
            "Failed to send reset email. Please try again."
        );
      });
  }
  useEffect(() => {
    if (errorMsg?.msg && errorMsg.msg.length > 0) {
      scrollError.current.scrollIntoView({
        inline: "center",
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [errorMsg]);
  function setMsgFlash(error, iserror = 1) {
    setErrorMsg({ msg: error, isError: iserror });
    setTimeout(() => {
      setErrorMsg({ msg: "", isError: 1 });
    }, 5000);
  }
  function validMail(email) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );
  }
  var passwordRulesSet = {
    "one lowercase character": /[a-z]/,
    "one uppercase character": /[A-Z]/,
    "one number": /[0-9]/,
    "one special character": /[^a-z0-9]/i,
    "8 characters minimum": /.{8,}/,
  };
const checkValidation = (rule, value) => {
  return new RegExp(rule).test(value);
};
  useEffect(() => {
    const elements = document.getElementsByClassName("passwordRules");
    if (elements.length === 0) return;
    var ruleselem = elements[0].getElementsByTagName("li");
    for (let i = 0; i < ruleselem.length; i++) {
      const isValid = checkValidation(
        passwordRulesSet[ruleselem[i].innerText.toLowerCase()],
        password
      );
      ruleselem[i].classList.toggle("pass", isValid);
  }
  }, [password, passwordError]);



  return (
    <div className="bg-white relative flex min-h-screen items-center justify-center">
      <img className="absolute left-[10px] top-1/4 -mt-48 hidden lg:block" width="300" height="490" src="./flag.svg"/>
      <img className="absolute right-[10px] bottom-[50px] -mt-48 hidden lg:block" width="300" height="490" src="./civilscodelogin.svg"/>
      <div className="w-full max-w-[550px] px-6 py-2 text-center md:px-12 md:pb-16">
        <div className="flex flex-col items-center">
          <div className="text-2xl sm:text-3xl font-bold mb-4 text-center">
            {isSignIn ? "Continue Your Preparation" : "Experience Smarter UPSC Preparation"}
         </div>
        </div>
        <div className="relative z-20 flex flex-col pt-4 md:pt-4">
          {!isSignIn && (<div className="mb-3">
             <button
  type="button"
  onClick={googlePrefill}
  className="google-prefill-btn"
>
  <img
    src="https://developers.google.com/identity/images/g-logo.png"
    alt="Google"
  />
  <span>Prefill with Google</span>
</button>
          </div>)}
          <form onSubmit={handleSubmit}>
            <Form.Group>
              {!isSignIn && (
                <div className="mb-3">
                  <Form.Control
                    placeholder="Name"
            type="name"
                    className={`p-3 w-full border rounded-md ${
                      nameError ? "border-red-500" : "border-gray-500"
                    } focus:outline-none focus:ring-2 focus:ring-green-400 text-grey-15 peer placeholder:text-base placeholder:text-grey-65`}
            value={name}
            tabindex="0"
            autoComplete="on"
                    onChange={(e) => {
                      setName(e.target.value);
                      setNameError("");
                    }}
                  />
                  {nameError && (
                    <div className="text-red-500 text-sm mt-1">{nameError}</div>
                  )}
                </div>
              )}
              <div className="mb-3">
                <Form.Control
                  placeholder="Email ID"
            autoComplete="on"
            tabindex="0"
            type="email"
                  className={`p-3 w-full border rounded-md ${
                    emailError ? "border-red-500" : "border-gray-500"
                  } focus:outline-none focus:ring-2 focus:ring-green-400 text-[var(--textmain1)] peer placeholder:text-base placeholder:text-grey-65`}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError("");
                  }}
                  onBlur={(e) => {
                    if (e.target.value === "") return;
                    if (!validMail(e.target.value)) {
                      setEmailError("Invalid Email ID");
                    }
                  }}
          />
                {emailError && (
                  <div className="text-red-500 text-sm mt-1">{emailError}</div>
                )}
              </div>
              {!isSignIn && (
                <div className="mb-3">
                  <Form.Control
                    placeholder="Confirm Email ID"
            tabindex="0"
                    className={`p-3 w-full border rounded-md ${
                      emailError ? "border-red-500" : "border-gray-500"
                    } focus:outline-none focus:ring-2 focus:ring-green-400 text-grey-15 peer placeholder:text-base placeholder:text-grey-65`}
                    disabled={!validMail(email) ? true : false}
                    value={email2}
                    onChange={(e) => {
                      setEmail2(e.target.value);
                      setEmailError("");
                    }}
                    onBlur={(e) => {
                      if (e.target.value !== email)
                        setEmailError("Mismatch with Email ID");
                      else setEmailError("");
                    }}
                  />
                </div>
              )}
              {!isSignIn && (
                <div className="mb-3">
                  <Form.Control
                    placeholder="Mobile Number(Ind)"
            type="number"
            autoComplete="off"
            tabindex="0"
                    className={`p-3 w-full border rounded-md ${
                      mobileError ? "border-red-500" : "border-gray-500"
                    } focus:outline-none focus:ring-2 focus:ring-green-400 text-grey-15 peer placeholder:text-base placeholder:text-grey-65`}
            value={mobilenumber}
                    onChange={(e) => {
                      if (!isNaN(e.target.value)) {
                        setMobileNumber(e.target.value);
                        setMobileError("");
                      }
                    }}
                    onBlur={(e) => {
                      e.preventDefault();
                      if (!validMobileNumber(e.target.value)) {
                        setMobileError("Invalid Indian mobile number");
                      }
                    }}
                    onWheel={(e) => {
                      e.preventDefault();
                      e.target.blur();
                    }}
                  />
                  {mobileError && (
                    <div className="text-red-500 text-sm mt-1">
                      {mobileError}
                    </div>
                  )}
                </div>
              )}
              <div className="passwordInputWithRules mb-3">
                <div className="relative w-full">
                  <Form.Control
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
              autoComplete="on"
              tabindex="0"
                    className={`p-3 w-full border rounded-md ${
                      passwordError ? "border-red-500" : "border-gray-500"
                    } focus:outline-none focus:ring-2 focus:ring-green-400 text-grey-15 peer placeholder:text-base placeholder:text-grey-65 pr-10`}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError("");
                    }}
                    onBlur={(e) => {
                      if (!isSignIn) {
                        const errorMsg = validatePassword(e.target.value);
                        if (errorMsg) {
                          setPasswordError(errorMsg);
                        } else setPasswordError(null);
                      }
                    }}
                    onWheel={(e) => {
                      e.preventDefault();
                      e.target.blur();
                    }}
            />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <EyeOff className="h-5 w-5 text-gray-400" />
                    ) : (
                      <Eye className="h-5 w-5 text-gray-400" />
                    )}
                  </button>
                </div>
                {passwordError && (
                  <div className="text-red-500 text-sm mt-1">
                    {passwordError}
                  </div>
                )}
                {!isSignIn && passwordError != null && (
                  <ul className="passwordRules mt-2 text-sm">
                    <li className="text-gray-600">One lowercase character</li>
                    <li className="text-gray-600">One uppercase character</li>
                    <li className="text-gray-600">One number</li>
                    <li className="text-gray-600">One special character</li>
                    <li className="text-gray-600">8 characters minimum</li>
             </ul>
                )}
          </div>
              {!isSignIn && (
                <div className="mb-3">
                  <div className="relative">
                    <Form.Control
                      placeholder="Confirm Password"
            tabindex="0"
                      type={showPassword2 ? "text" : "password"}
                      className={`p-3 w-full border rounded-md ${
                        passwordError ? "border-red-500" : "border-gray-500"
                      } focus:outline-none focus:ring-2 focus:ring-green-400 text-grey-15 peer placeholder:text-base placeholder:text-grey-65 pr-10`}
            disabled={password.length===0 ? true : false}
                      value={password2}
                      onChange={(e) => {
                        setPassword2(e.target.value);
                      }}
                      onBlur={(e) => {
                        if (e.target.value !== password)
                          setPasswordError("Mismatch in passwords");
                        else setPasswordError(null);
                      }}
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 pr-3 flex items-center"
                      onClick={() => setShowPassword2(!showPassword2)}
                    >
                      {showPassword2 ? (
                        <EyeOff className="h-5 w-5 text-gray-400" />
                      ) : (
                        <Eye className="h-5 w-5 text-gray-400" />
                      )}
                    </button>
                  </div>
                </div>
              )}
              {!isSignIn && (
                <div className="mb-4">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="agreement"
                      checked={isAgreementChecked}
                      onChange={(e) => setIsAgreementChecked(e.target.checked)}
                      className="h-4 w-4 text-green-500 focus:ring-green-400 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="agreement"
                      className="ml-2 block text-sm text-gray-700"
                    >
                      I agree to the{" "}
                      <a
                        className="font-medium text-green-500"
                        target="_blank"
                        href="/terms-of-service"
                      >
                        Terms of Service
                      </a>{" "}
                      and{" "}
                      <a
                        className="font-medium text-green-500"
                        target="_blank"
                        href="privacy-policy"
                      >
                        Privacy Policy
                      </a>
            </label>
        </div>
                </div>
              )}
              <button
                className={`login-signup-button p-3 w-full rounded-md text-white flex justify-center p-3 w-full rounded-md border 
                ${
                  isLoading || !isFormValid
                    ? "bg-[#cccccc] border-[#cccccc] cursor-not-allowed"
                    : "bg-primary-color hover:bg-green-600 transition-all"
        }
                mt-4`}
                disabled={isLoading || !isFormValid}
                type="submit"
              >
                {isLoading ? (
                  <span className="flex items-center">
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    {isSignIn ? "Signing In..." : "Signing Up..."}
                  </span>
                ) : (
                  <span>{isSignIn ? "Sign In" : "Sign Up"}</span>
                )}
              </button>
              {isSignIn && validMail(email) && (
                <div
                  className="text-center p-2 cursor-pointer hover:underline text-green-500"
                  onClick={ResetPassword}
                >
                  Reset Password
        </div>
              )}
        </Form.Group>
      </form>
          <div
            ref={scrollError}
            className={
              errorMsg?.msg && errorMsg.msg.length
                ? `ErrorDisplay p-3 my-3 rounded-md ${
                    errorMsg.isError === 1
                      ? "bg-red-100 text-red-700"
                      : "bg-green-100 text-green-700"
                  }`
                : "hidden"
            }
          >
            {errorMsg.msg}
      </div>
          {isSignIn && (
            <a
              className="block w-full px-6 py-2 text-m14 text-grey-45"
              href="/signup"
            >
              Don't have an account?{" "}
              <span className="font-semibold text-green-500">Sign up</span>
            </a>
          )}
          {!isSignIn && (
            <a className="block w-full px-6 py-2 text-gray-700" href="/login">
              Already have an account?{" "}
              <span className="font-semibold text-green-500">Log in</span>
            </a>
          )}
    </div>
    </div>
    </div>
  );
};
export default Login;
